import React, { useState } from 'react'
import moment from 'moment'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import AnDateTimePicker from '../../../../../../components/DateTime/DateTimePicker'
import TreatmentText from '../../TreatmentText'
import TreatmentOutcome from '../../TreatmentOutcome'
import InjuryType from './InjuryType'
import AffectedArea from './AffectedArea'
import SplintType from './SplintType'
import ImmobilisationDevice from './ImmobilisationDevice'
import LimbPosition from './LimbPosition'
import CirculationStatus from './CirculationStatus'
import SensoryMotorFunction from './SensoryMotorFunction'
import TreatmentSubmitModule from '../../TreatmentSubmitButton'

const Splinting = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Box padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Splinting & Immobilisation</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <InjuryType
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <AffectedArea
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <SplintType
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <ImmobilisationDevice
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <LimbPosition
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <CirculationStatus
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <SensoryMotorFunction
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <TreatmentOutcome
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
          lg={8}

        />
        <TreatmentText
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <TreatmentSubmitModule
          submitModule={submitModule}
          moduleValues={moduleValues}
          moduleName="Splinting & Immobilisation"
        />
      </Grid>
    </Box>
  )
}

export default Splinting
